import { http } from '../common/utils';
import { CLASSTING_API_URL } from '../common/constants';

export function* fetchSchools({ query } = {}) {
  const response = yield http.get(
    `${CLASSTING_API_URL}/v1/schools`,
    { params: { q: query } },
  );

  return response;
}

export const fetchSchool = ({ sid }) => http.get(`${CLASSTING_API_URL}/v1/schools/${sid}`);
